import BaseModel from "../base/BaseModel.model";

export default class PermissionAccess extends BaseModel {

  view:boolean= true;
  write:boolean = true;
  managment:boolean = true;
  permissionAccessLevel:boolean =  true;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.id = 0;
    this.view = true;
    this.write = true;
    this.managment = true;
    this.permissionAccessLevel = true;
  }
}
